module.exports = __webpack_public_path__ + "img/Pulverização manual.7b999338.webp";